/*
 * @Author: yeyimei
 * @Date: 2022-11-11 11:47:48
 * @LastEditTime: 2023-02-13 09:51:44
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\router\mc.routes.js
 */

// export default [{
//     path: "/mc/home",
//     name: "mcHome",
//     component: () =>
//         import(
//             "@/views/mc/home.vue"
//         ),
//     meta: {
//         title: "麦当劳",
//     },
// }]

export default [{
    path: '/mc/home',
    name: 'mcHome',
    component: () => import('@/views/mc/home.vue'),
    meta: {
      title: '麦当劳',
      showName:true
    },
  },
  {
    path: '/mc/store-list',
    name: 'mcStoreList',
    component: () => import('@/views/mc/storeList.vue'),
    meta: {
      title: '麦当劳',
    },
  },
  {
    path: '/mc/order',
    name: 'mcOrder',
    component: () => import('@/views/mc/order.vue'),
    meta: {
      title: '麦当劳',
    },
  },
  {
    path: '/mc/comfirm-pay',
    name: 'mcComfirmPay',
    component: () => import('@/views/mc/confirmPay.vue'),
    meta: {
      title: '确认付款',
    },
  },
  {
    path: '/mc/order-list',
    name: 'mcOrderList',
    component: () => import('@/views/mc/orderList.vue'),
    meta: {
      title: '麦当劳订单',
    },
  },
  {
    path: '/mc/order-detail',
    name: 'mcOrderDetail',
    component: () => import('@/views/mc/orderDetail.vue'),
    meta: {
      title: '麦当劳订单详情',
    },
  },
   {
    path: '/mc/order-notice',
    name: 'mcOrderNotice',
    component: () => import('@/views/mc/orderNotice.vue'),
    meta: {
      title: '点餐须知',
    },
  }
 
]